export const polyfillArrayFindLast = () => {
  if (typeof Array.prototype.findLast === 'function') {
    return;
  }

  Object.defineProperty(Array.prototype, 'findLast', {
    configurable: true,
    writable: true,
    value: function findLast<T>(
      this: T[],
      predicate: (value: T, index: number, array: T[]) => unknown,
      thisArg?: unknown,
    ) {
      for (let index = this.length - 1; index >= 0; index -= 1) {
        if (predicate.call(thisArg, this[index], index, this)) {
          return this[index];
        }
      }

      return undefined;
    },
  });
};
